import { fetchPostCreditCardTellMoneyUserConsent } from '@iwoca/lapi-client/edge';
import { useMutation } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

type UsePostTellMoneyUserConsentProps = {
    consentId: string;
    approved: boolean;
};

export const usePostTellMoneyUserConsent = () => {
    const stateKey = useStateKey();

    return useMutation({
        mutationFn: ({
            consentId,
            approved
        }: UsePostTellMoneyUserConsentProps) =>
            fetchPostCreditCardTellMoneyUserConsent({
                stateKey,
                consentId,
                body: { approved }
            })
    });
};
